//
// MapChartOperations.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "./ControllerOperations";
import "@sas-dvr/ltjs-commons/maps/MapSearchResult";
import "@sas-dvr/ltjs-commons/maps/GeoEnrichmentResult";
import "@sas-dvr/ltjs-commons/maps/MapSearchHint";
import "./DragMode";
import "../../layoutOverlayMap/map/MapPin";
import "../../state/RendererState";
import "./LocationOperations";

var MapChartOperations = createModule("gtl_MapChartOperations", [20086,20271], EventDispatcher, [
    {
        MAP_PROVIDER_CHANGED: 30061,
        REVERSE_GEOCODE_COMPLETE: 30064,
        SEARCH_HINTS_READY: 30065,
        PIN_SELECTED: 30059,
        MAP_BOUNDS_CHANGED: 30060,
        LOCATION_UPDATED: 30070,
        ESRI_ROUTE_COMPLETE: 30068,
        CURRENT_SEARCH_MARKER_SELECTED: 30058,
        MAP_VIEW_CHANGING: 30062,
        PINS_UPDATED: 30069,
        ESRI_DRIVETIME_COMPLETE: 30066,
        ESRI_GEO_ENRICHMENT_COMPLETE: 30067,
        SEARCH_COMPLETE: 30063,
    },
    ,
    ,
    {
        currentSearchMarkerIndex: 3,
        currentPinIndex: 4,
        esriPremiumToken: 7,
    },
    {
        addPin: [1,11,2],
        deleteSearchResults: [0,[3]],
        requestSearchHints: [0,7],
        doDriveTime: [0,11,2,[5],4,7],
        cancelDriveTime: [0],
        setShouldInstallBrushController: [0,2],
        addPinCopy: [1,1],
        getViewSize: [13,4],
        getGeoEnrichmentResultModels: [[1]],
        reverseGeocode: [0,11,2],
        getSearchHints: [[1]],
        getCurrentSearchMarkerLocation: [11],
        getReverseGeocodeResult: [1],
        canDoDistanceSelections: [2],
        canDoSearch: [2],
        canZoomOut: [2],
        resetView: [0],
        doRadial: [0,11,2,5,4],
        getSearchResults: [[1]],
        convertPixelToLatLon: [11,11],
        getPinState: [1],
        createPointBuffer: [1,11,2,1,4],
        getDragMode: [4],
        getLocationOperations: [1],
        getSelectionPolygonCenter: [11,2],
        pointInsideSelectionPolygon: [2,11],
        shouldInstallBrushController: [2],
        getSearchTerm: [7],
        setViewport: [0,12,2],
        listenForLocation: [0,2],
        enrichSelectionPolygon: [0,[7],7],
        canZoomIn: [2],
        search: [0,7,7,11],
        cancelReverseGeocode: [0],
        clearPins: [0],
        getLastLocation: [11],
        getSearchPins: [[1]],
        addPinToMap: [0,1],
        setWebMapConstraints: [0,1],
        hasSelection: [2],
        zoom: [0,5],
        getMapDataBounds: [12],
        doDriveTimeWithTraffic: [0,11,2,[5],4,7,4,4,4,4],
        getMaximumBufferDistance: [5,4,4],
        clearSearch: [0],
        getGeoEnrichmentResults: [7],
        getMapBounds: [12],
        deletePin: [0,1],
        cancelSearch: [0],
        createRoute: [0,11,11,2,1],
        cancelRoute: [0],
        getPins: [[1]],
        setVisualStyleOverride: [0,2],
        clearSelections: [0],
        setPinState: [0,1],
    },
    ,
    ,
]);
export default MapChartOperations;
